import { useLocation, useNavigate } from "react-router";

interface BackButtonProps {
  /**
   * Where back goes when there is no history to pop. A deep link, a refresh or a link from an email all land on a
   * screen with an empty history stack, so naming the parent screen means back always stays inside the app.
   */
  to?: string | undefined;
  label?: string | undefined;
}

/** The one back control, so every screen's looks and behaves the same. */
export function BackButton({ to = "/hub", label = "Back" }: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    // `key` is "default" only on the first entry a router ever has: that is "opened straight here".
    if (location.key !== "default") {
      void navigate(-1);
      return;
    }
    void navigate(to, { replace: true });
  };

  return (
    <button
      type="button"
      onClick={goBack}
      className="inline-flex min-h-11 items-center justify-center rounded-[var(--radius-control)] border-[1.5px] border-border bg-transparent px-5 text-[14.5px] font-bold text-accent hover:border-accent hover:bg-accent-tint"
    >
      ← {label}
    </button>
  );
}
